import { api_base } from './../constants/services/api';
import { LOCAL_STORAGE } from "../constants/services/api";

var api = `${api_base}`;

export async function sendService(url, method = 'GET', data = {}) {
  var session = localStorage.getItem(LOCAL_STORAGE);
  var token = ''
  if (session !== null || session === '') {
    var temp = JSON.parse(session);
    token = temp.token;
  }
  let props = {
    method: method.toUpperCase(),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  }
  if (method.toUpperCase() !== 'GET') {
    props = {
      ...props,
      body: JSON.stringify(data)
    }   
  }

  try {
    var respFetch = await fetch(api + url, props)
    const respJson = await respFetch.json()
    // console.log(respJson)
    return {
      status: respFetch.status,
      response: respJson
    }
  } catch (error) {
    console.log(url)
    console.log(error)
    return { status: 499 }
  }
}

export function sendFile(url, data = new FormData(), functions = { start: () => { }, end: () => { }, onprogress: () => { }, error: () => { } }) {
  var session = localStorage.getItem(LOCAL_STORAGE);
  var token = ''
  if (session !== null || session === '') {
    var temp = JSON.parse(session);
    token = temp.token;
  }
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        functions.end(JSON.parse(this.response))
      }
      else {
        console.error(this.responseText);
        functions.error(JSON.stringify(this.response))
      }
    }
  };
  xhr.onloadstart = functions.start
  xhr.onprogress = functions.onprogress
  xhr.open("POST", api + url, true);
  xhr.setRequestHeader('authorization', 'Bearer ' + token)
  xhr.send(data);
}

export const makeId = (length = 12) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const answerOk = (ans, onError) => {
  if (ans.status === 200) return true
  if (ans.status === 401 || ans.status === 403) {
    onError()
    return false
  }
  alert("Problemas con la conexión, intente mas tarde");
  onError()
  return false
}

export async function getMasterRef(table) {
  const resp = await sendService('/api/v1/dashboard/getMaster/' + table)
  return resp.response
}

export function getMasterRefAsync(table) {
  return sendService('/api/v1/dashboard/getMaster/' + table)
}

export function sendServiceAsync(url, method = 'GET', data = {}) {
  var session = localStorage.getItem(LOCAL_STORAGE);
  var token = ''
  if (session !== null || session === '') {
    var temp = JSON.parse(session);
    token = temp.token;
  }
  let props = {
    method: method.toUpperCase(),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  }

  if (method.toUpperCase() !== 'GET') {
    props = {
      ...props,
      body: JSON.stringify(data)
    }
  }

  return fetch(api + url, props)
}

export const openFile = (dataResp, filename) => {  
  let dataType = dataResp.type
  let binaryData = []
  binaryData.push(dataResp)
  let downloadLink = document.createElement('a')
  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }))
  downloadLink.setAttribute('download', filename)
  document.body.appendChild(downloadLink)
  downloadLink.click()
}